import { supabase } from "@/integrations/supabase/client";

interface IntegrationEvent {
  type: 'document_created' | 'document_updated' | 'document_shared' | 'member_invited' | 'assessment_completed';
  data: Record<string, any>;
}

export const triggerIntegrations = async (eventType: IntegrationEvent['type'], eventData: Record<string, any>) => {
  try {
    // Get user's organization ID
    const { data: { user } } = await supabase.auth.getUser();
    if (!user) return;

    const { data: membership } = await supabase
      .from('organization_memberships')
      .select('organization_id')
      .eq('user_id', user.id)
      .single();

    if (!membership) return;

    // Get organization integrations
    const { data: organization } = await supabase
      .from('organizations')
      .select('branding')
      .eq('id', membership.organization_id)
      .single();

    if (!organization?.branding) return;

    const integrations = (organization.branding as any)?.integrations || {};
    
    // Trigger each enabled integration
    const integrationPromises = Object.entries(integrations)
      .filter(([_, config]: [string, any]) => config.enabled)
      .map(([integrationId, config]: [string, any]) => 
        triggerSingleIntegration(integrationId, config, eventType, eventData, membership.organization_id)
      );

    await Promise.allSettled(integrationPromises);
  } catch (error) {
    console.error('Error triggering integrations:', error);
  }
};

const triggerSingleIntegration = async (
  integrationId: string, 
  config: any, 
  eventType: string, 
  eventData: Record<string, any>,
  organizationId: string
) => {
  try {
    await supabase.functions.invoke('trigger-integration-event', {
      body: {
        integrationId,
        config,
        eventType,
        eventData,
        organizationId,
        timestamp: new Date().toISOString()
      }
    });
  } catch (error) {
    console.error(`Error triggering ${integrationId} integration:`, error);
  }
};